import React from 'react';

interface TargetColumnProps {
  value: string;
}

export default React.memo((props: TargetColumnProps) => {
  const { value } = props;
  if (!value) {
    return <>TBD</>;
  }
  return <b>{value}</b>;
});
